import type React from 'react'
import type { JSX } from 'react'

import { CARDS_ASPECT_RATIO } from 'blocks/Cards'
import { GridSkeleton, Skeleton } from 'blocks/Skeletons'
import { CardsInRow } from 'containers/RowContainer'
import { FIXED_INDENTS, LAYOUT } from 'vars/index'
import { RowSkeleton } from '../components/RowSkeleton/RowSkeleton'
import { SkeletonUnitMargins } from '../components/SkeletonUnit'
import { CategoriesTabsSkeletonUnit } from '../components/SkeletonUnit/Templates'

export interface ICatchupsPageSkeleton {
  rowCardsAspectRatio?: number
  paddings?: (LAYOUT | FIXED_INDENTS)[]
  totalRowsInGrid?: number
  tvChannelCard?: boolean
  cardsInRow: CardsInRow
  cardsInGrid: CardsInRow
  children?: React.ReactNode
}

export const CatchupsPageSkeleton = ({
  // paddings = [
  //   FIXED_INDENTS.INDENT_70,
  //   LAYOUT.HorizontalPaddings,
  //   FIXED_INDENTS.INDENT_0,
  // ],
  cardsInRow = CardsInRow.Horizontal_6,
  cardsInGrid = CardsInRow.Horizontal_5,
  totalRowsInGrid,
  children,
}: ICatchupsPageSkeleton): JSX.Element => {
  return (
    <Skeleton>
      {children || (
        <>
          <RowSkeleton
            cardsInRow={cardsInRow}
            tvChannelCard={true}
            withTitle={false}
            cardsAspectRatio={CARDS_ASPECT_RATIO.HORIZONTAL_TRIA_DEFAULT}
            verticalPaddings={FIXED_INDENTS.INDENT_70}
          />
          <CategoriesTabsSkeletonUnit
            height={'40px'}
            margins={SkeletonUnitMargins.SIZE_100}
          />
          <GridSkeleton
            cardsInRow={cardsInGrid}
            totalRows={totalRowsInGrid}
            cardsAspectRatio={CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT}
            tvChannelCard={false}
            withTitle={false}
            height={'auto'}
          />
        </>
      )}
    </Skeleton>
  )
}
